import React, { useState, useRef, useEffect } from "react";
import { Toast } from "bootstrap";
import "./Notification.scss";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const colors = {
  success: "#5cb85c",
  error: "white",
  info: "#5bc0de",
  warning: "#f0ad4e",
};

const Notification = ({ notification, setNotification }) => {
  const { type, title } = notification;
  const [toast, setToast] = useState(true);
  const toastRef = useRef();

  useEffect(() => {
    const myToast = toastRef.current;
    const bsToast = new Toast(myToast, { autohide: false });
    toast ? bsToast.show() : bsToast.hide();
    const interval = setInterval(() => {
      closeNotification();
    }, 3000);
    return () => {
      clearInterval(interval);
    };
  });

  const closeNotification = () => {
    setNotification(undefined);
    setToast(false);
  };

  return (
    <div>
      {toast && (
        <div
          style={{
            backgroundColor: `${colors[type]}`,
          }}
          className="toast w3-animate-right"
          ref={toastRef}
        >
          <div className="toast-body row">
            <span className="col-2 icon-alert"><ErrorOutlineIcon style={{fontSize:'42px'}} className="text-warning ">{type.toUpperCase()}</ErrorOutlineIcon></span>
            <span className="alert-text col-10">{title}</span>
          </div>
        </div>
      )}
    </div>
  );
};
export default Notification;
